<template>
    <div class="navbar-wrapper text-nowrap">
        <b-navbar toggleable variant="faded" fixed="top" class="z-depth-1 navbar-expand-sm">
            <b-link v-if="isExpert || isAdmin" class="navbar-brand" to="/">
                <img alt="Future Talents" src="~@/assets/images/logo.png" height="45">
            </b-link>

            <b-navbar-nav>
                <b-nav-item v-if="isExpert || isAdmin" to="/">
                    Időpontjaim
                </b-nav-item>
                <b-nav-item v-if="isExpert || isAdmin" to="/utobbi1honap">
                    Utóbbi 1 hónap
                </b-nav-item>
                <b-nav-item v-if="isExpert || isAdmin" to="/adataim">
                    Fogadási órák
                </b-nav-item>
                <b-nav-item v-if="isExpert || isAdmin" to="/szabadsagok">
                    Szabadságok
                </b-nav-item>
                <b-nav-item v-if="isAdmin" to="/tanacsadok">
                    Tanácsadók
                </b-nav-item>
                <b-nav-item v-if="isAdmin" to="/allasok">
                    Állások
                </b-nav-item>
                <b-nav-item v-if="isAdmin" to="/jelentkezesek">
                    Jelentkezések
                </b-nav-item>
            </b-navbar-nav>

            <b-navbar-nav class="ml-auto">
                <b-nav-item href="#" @click="logoutButton()">
                    Kijelentkezés
                </b-nav-item>
            </b-navbar-nav>
        </b-navbar>

        <transition name="slide-down" @enter="onShowNavMessage" @leave="onHideNavMessage">
            <div class="py-1 c-mb-15 nav-message" v-if="showNavMessages">
                <div class="px-3" v-for="(navMessage, index) in navMessages" :key="index">
                    <span v-html="navMessage.message"></span>
                </div>
            </div>
        </transition>

        <div class="nav-message-proxy"></div>
    </div>

</template>

<script type="text/babel">
    import Vue from 'vue';
    import { isLoggedIn, getUserData, logout, isAdmin, isExpert } from '@/util/expert/auth';

    export default Vue.extend({
        props: ['navMessages'],
        data() {
            return {
                isLoggedIn: isLoggedIn(),
                isAdmin: isAdmin(),
                isExpert: isExpert(),
                iconPlusName: '<i class="fa fa-user mr-1"></i> ' + getUserData('name'),
                email: getUserData('email'),
            };
        },
        computed: {
            showNavMessages() {
                return _.size(this.navMessages);
            },
        },
        methods: {
            logoutButton() {
                logout();
            },
            hasAdminRoute() {
                return (typeof this.$route.meta.group !== 'undefined' && this.$route.meta.group === 'admin' ? true : false);
            },
            hasRoute(name) {
                return (this.$route.name === name);
            },
            hasRouteGroup(group) {
                return (this.$route.meta.group === group);
            },
            onShowNavMessage() {
                this.$nextTick(() => {
                    let proxy = $('.nav-message-proxy');
                    let height = ($('.nav-message').get(0).offsetHeight - 15) + 'px';

                    proxy.css('height', height);
                    proxy.css('max-height', height);
                });
            },
            onHideNavMessage() {
                this.$nextTick(() => {
                    let proxy = $('.nav-message-proxy');

                    proxy.css('height', 0);
                    proxy.css('max-height', 0);
                });
            },
        }
    });
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
    .navbar {
        background: #fff;
        border: none;
        padding-left: 0;
        padding-top: 0;
        padding-bottom: 0;
        height: 55px;

        .navbar-brand {
            background: #fff;
            color: #fff;
            font-size: 16px;
            font-weight: 500;
            padding: 5px 11px;
            height: 100%;
        }

        ul.navbar-nav {
            li.nav-item {
                padding-left: 4px;
                padding-right: 4px;

                a.nav-link {
                    padding: 1rem 0.5rem;

                    span {
                        color: #fff;
                    }
                }
            }
        }
    }

    .nav-message {
        font-size: 14px;
        background: #e2e2e2;
        border-bottom: 1px solid #ccc;
        z-index: 1010;
        width: 100%;
        margin-top: calc(48px - 5rem);
        position: fixed;
    }

    .nav-message-proxy {
        height: 0;
        max-height: 0;
        transition: .5s;
    }

    .slide-down-leave-active,
    .slide-down-enter-active {
        transition: .5s;
    }

    .slide-down-enter, .slide-down-leave-to {
        transform: translate(0, -100%);
    }
</style>

<style lang="scss" rel="stylesheet/scss">
    ul.navbar-nav {
        height: 100%;

        li.nav-item {
            padding-left: 4px;
            padding-right: 4px;
        }

        li.nav-item:not(.active) {
            a.nav-link {
                margin-top: 4px;
            }
        }
    }

    ul.navbar-nav li.nav-item.active {
        background-color: #fff;
        padding: 4px;

        a.nav-link,
        a.nav-link.active,
        a.nav-link:hover {
            color: red !important;
        }
    }
</style>
